import React from 'react';
import DefaultLayout from './containers/DefaultLayout';

const Templates = React.lazy(() => import('./views/Templates'));
// const Skills = React.lazy(() => import('./views/Skills/List/SkillsList'))
// const DeviceInfo = React.lazy(() => import('./views/BotInfo/BotInfo'))
const BotDescription = React.lazy(() => import('./views/BotDescription/BotDescription'));
const Profile = React.lazy(() => import('./views/Profile/Profile'));

const HelpToImprove = React.lazy(()=>import('./views/HelpToImprove/HelpToImprove'));
const YourOrderDetails= React.lazy(()=>import('./views/OrderSummary/OrderSummary'));
const PaymentSuccessful= React.lazy(()=>import('./views/PaymentSuccessful/PaymentSuccessful'));
const PaymentResponse = React.lazy(() => import('./views/PaymentResponse/PaymentResponse'));
const PaymentFailed=React.lazy(()=>import('./views/PaymentFailed/PaymentFailed'));
const PlanUpgrade = React.lazy(() =>import('./views/PlanUpgrade/PlanUpgrade'));
const PrintInvoice = React.lazy(() => import('./views/ProfileContent/PrintInvoice/PrintInvoice'));

const ListUserRolePermisions = React.lazy(()=> import('./views/RolesAndPermissions/List/ListRolesAndPermissions'));
const EditUserRolePermisions = React.lazy(()=> import('./views/RolesAndPermissions/Edit/EditUserRoleAndPermissions'));

const UserDetails = React.lazy(() => import('./views/ProfileContent/UserDetails/UserDetails'));
const routes = [
        { path: '/', name: 'Template', component: DefaultLayout, exact: true },
        { path: '/home', name: '', component: Templates ,exact: true},
        // { path: '/devinfo', name: 'Device Info', component: DeviceInfo, exact: true},
        // { path: '/skills', name: '', component: Skills ,exact: true},
        { path: '/botdescription/:id', name: 'Bot Description', component: BotDescription ,exact: true},
        { path: '/profile', name: 'Profile', component: Profile ,exact: true},
        { path: '/feedback', name: 'FeedBack', component: HelpToImprove ,exact: true},
        { path: '/ordersummary/:skillId', name: 'Order Details', component: YourOrderDetails ,exact: true},
        { path: '/paymentsuccessful', name: 'Payment Successful', component: PaymentSuccessful ,exact: true},
        { path: '/paymentresponse', name: 'Payment Response', component: PaymentResponse},
        { path: '/paymentfailed', name: 'Payment Failed', component: PaymentFailed ,exact: true},
        { path: '/plans', name: 'Plan Upgrade', component: PlanUpgrade, exact:true},
        { path: '/plans/:skillId/:subscriptionId/:template/:skillName', name: 'Plan Upgrade', component: PlanUpgrade, exact:true},
        { path: '/invoice', name: 'Print Invoice', component: PrintInvoice, exact:true},
        
        { path: '/roles/', name: 'List Roles', component: ListUserRolePermisions ,exact: true},
        { path: '/roles/add/', name: 'addRole', component: EditUserRolePermisions ,exact: true},
        { path: '/roles/edit/:id', name: 'editRole', component: EditUserRolePermisions ,exact: true},	

        { path: '/users', name: 'Users', component: UserDetails ,exact: true},
];

export default routes;
